import React from 'react';
import Helmet from "react-helmet";
import {Card, CardGroup, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';

import speaker from "../../assets/images/contents/AssociateProfDrKunZhan.jpg"

export const AssociateProfDrKunZhan = () => (
  <div>
    <Helmet>
      <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Associate Prof Dr Kun Zhan</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Associate Prof Dr Kun Zhan</b>
    </p>

    <p style={{textAlign:'center'}}>
    School of Information Science & Engineering, Lanzhou University 
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Multiview Clustering Strategy for Multiple Features in Data Analytics</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      Performing transductive learning on graphs with very few labeled data, that is, two or three samples for each category, is challenging due to the lack of supervision. 
      In the existing work, self-supervised learning via a single view model is widely adopted to address the problem. However, recent observation shows multiview representations 
      of an object share the same semantic information in high-level feature space. For each sample, we generate heterogeneous representations and use view-consistency loss to 
      make their representations consistent with each other. Multiview representation also inspires to supervise the pseudo labels generation with the aid of mutual supervision 
      between views. The speech will focus on a view-consistent heterogeneous network to learn better representations by aligning view-agnostic semantics. Also, stationary 
      Diffusion State Neural Estimation to exploit multiview structural graph information for co-supervised learning.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
        Kun Zhan received B.S. and Ph.D. degrees from Lanzhou University, in 2005 and 2010, respectively. He was a visiting student with Dalhousie University from 2009 to 
        2010 and was a visiting scholar with University of Technology Sydney from 2017 to 2018. He is currently with Lanzhou University and a visiting professor in Baoji 
        University of Arts and Sciences. He presently works on supervised/ unsupervised of the heterogeneous multi-view clustering data and graph clustering. 
    </p>

  </div>
)